export default "__VITE_ASSET__Cuv2paGs__"